import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FunctionalDivisionList from '@/views/downLoadCenter/functionalDivisionList.vue';
import startedByme from "@/views/cardSystem/saleToos/projectDelivery/startedByme.vue";
import myToDo from "@/views/cardSystem/saleToos/projectDelivery/myToDo.vue";
import myReview from "@/views/cardSystem/saleToos/projectDelivery/myReview.vue";
export default {
  name: 'artilleryFirelist',
  components: {
    FunctionalDivisionList: FunctionalDivisionList,
    startedByme: startedByme,
    myToDo: myToDo,
    myReview: myReview
  },
  data: function data() {
    return {
      activeTab: '1',
      tabs: [{
        name: '1',
        label: '我发起的申请',
        component: 'startedByme',
        permission: '/orders/project-delivery/initiated-by-me'
      }, {
        name: '2',
        label: '我的待办',
        component: 'myToDo',
        permission: '/orders/project-delivery/my-to-do'
      }, {
        name: '3',
        label: this.reviewLabel,
        component: 'myReview',
        permission: '/orders/project-delivery/my-review'
      }, {
        name: '4',
        label: '职能部门分工',
        component: 'FunctionalDivisionList',
        permission: '/orders/project-delivery/division-of-labor'
      }],
      reviewCount: 0
    };
  },
  computed: {
    reviewLabel: function reviewLabel() {
      return this.reviewCount ? "\u6211\u7684\u5BA1\u6838(".concat(this.reviewCount, ")") : '我的审核';
    }
  },
  watch: {
    activeTab: function activeTab(newVal) {
      var _this = this;
      if (newVal === '3') {
        this.$nextTick(function () {
          var comp = _this.$refs.myReviewDom;
          if (comp && typeof comp.resetList === 'function') {
            comp.resetList();
          }
        });
      }
    }
  },
  created: function created() {
    this.setDefaultActiveTab();
  },
  mounted: function mounted() {
    var _this2 = this;
    if (this.$hasBtnRoles('/orders/project-delivery/my-review')) {
      this.$nextTick(function () {
        var comp = _this2.$refs.myReviewDom;
        if (comp && typeof comp.getlist === 'function') {
          comp.getlist();
        }
      });
    }
  },
  methods: {
    setDefaultActiveTab: function setDefaultActiveTab() {
      var _this3 = this;
      var visibleTabs = this.tabs.filter(function (tab) {
        return _this3.$hasBtnRoles(tab.permission);
      });
      this.activeTab = visibleTabs.length ? visibleTabs[0].name : '';
    },
    getCount: function getCount() {
      var comp = this.$refs.myReviewDom;
      if (comp && typeof comp.getlist === 'function') {
        comp.getlist();
      }
    }
  }
};